import React from 'react'
import { Link, Redirect } from 'react-router-dom'
import { config } from '../Config/config'
import userService from '../Service/userService'
import { Modal } from 'react-bootstrap'
// import { config } from '../Configure/config'
// import userService from '../Service/loginService'
export default class login extends React.Component {
    constructor() {
        super()
        this.state = {
            formdata: {
                email: '',
                password: '',
                remember: false
            },
            cekEmail: "",
            cekPass: '',
            is_locked: false,
            errors: {},
            config: {},
            type:"password",
            icon:"visibility_off",
            falsecount:0
        }
    }

    changeHandler = field => ({ target: { value } }) => {
        this.setState({
            formdata: {
                ...this.state.formdata,
                [field]: value
            }
        })
    }

    onSignIn = async () => {
        const responEmail = await userService.cekEmail(this.state.formdata.email)
        console.log(responEmail)
        if (responEmail.success) {
            if (responEmail.result != undefined) {
                this.setState({
                    cekEmail: responEmail.result.email,
                    cekPass: responEmail.result.password,
                    is_locked: responEmail.result.is_locked,
                    config: responEmail.result
                })
                userService.Loginatt(this.state.config)
            }
        }
        if (this.handleValidation()) {
            localStorage.setItem(config.username, this.state.config.username)
            localStorage.setItem(config.userid, this.state.config._id)
            localStorage.setItem(config.token, this.state.config.token)
            localStorage.setItem(config.role, this.state.config.role)
            localStorage.setItem(config.biodata_id, this.state.config.biodata_id)
            if (this.state.config.image_path != "") {
                localStorage.setItem(config.image_path, this.state.config.image_path)
            } else {
                localStorage.setItem(config.image_path, "assets/img/user.jpg")
            }
            localStorage.setItem(config.remember, `${this.state.formdata.remember}`)
            await userService.lastLogin(this.state.config)
            window.location.reload()
        }
    }

    handleValidation() {
        const { cekEmail, cekPass, is_locked } = this.state
        let fields = this.state.formdata;
        let errors = {};
        let formIsValid = true;

        //Email
        if (fields["email"] !== cekEmail) {
            formIsValid = false;
            errors["password"] = "The password/email that you've entered is incorrect.";

        }

        if (typeof fields["email"] !== "undefined") {
            let lastAtPos = fields["email"].lastIndexOf('@');
            let lastDotPos = fields["email"].lastIndexOf('.');

            if (!(lastAtPos < lastDotPos && lastAtPos > 0 && fields["email"].indexOf('@@') == -1 && lastDotPos > 2 && (fields["email"].length - lastDotPos) > 2)) {
                formIsValid = false;
                errors["email"] = "Email is not valid";
            }
        }



        if (!fields["email"]) {
            formIsValid = false;
            errors["email"] = "Cannot be empty";
        }

        if (!fields["password"]) {
            formIsValid = false;
            errors["passwordkos"] = "Cannot be empty";
        }

        //Pass

        if (fields["password"] !== cekPass && fields["email"] === cekEmail) {
            formIsValid = false;
            errors["password"] = "The password/email that you've entered is incorrect.";
            this.setState({
                falsecount:this.state.falsecount+1
            },()=>{if (this.state.falsecount%3==0) {
                this.props.ModalLupassHandler()
                this.setState({
                    errors:{}
                })
            }})
        }

        if (is_locked === true) {
            formIsValid = false;
            // errors["is_locked"] = "your accound is locked by admin, contact adminastator for detail.";
            alert("your accound is locked by admin, contact adminastator for detail.")
            window.location.href = '/'
        }

        this.setState({ errors: errors });
        return formIsValid;
    }

    onEnter = (event) => {
        if (event.key === 'Enter') {
            this.onSignIn()
        }
    }

    checkedHandler = field => ({ target: { checked } }) => {
        this.setState({
            formdata: {
                ...this.state.formdata,
                [field]: checked
            }
        })
    }

    onEye = ()=>{
        if (this.state.type=="password") {
            this.setState({
                type:"text",
                icon:"visibility"
            })
        }else{
            this.setState({
                type:"password",
                icon:"visibility_off"
            })
        }
    }

    cancelHandler = () => {
        this.setState({
            errors:{}
        },()=>{this.props.cancelHandler()})
    }

    render() {
        const { errors,type,icon } = this.state
        const { ShowModal, ModalRegHandler, ModalLupassHandler } = this.props
        return (
            <div>
                <Modal show={ShowModal} onHide={this.cancelHandler}>
                    <Modal.Header closeButton>
                        <Modal.Title>Login</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {/* {JSON.stringify(this.state.formdata)} */}
                        <div class="main-wrapper account-wrapper">
                            <div >
                                <div >
                                    <div >
                                        <form action="javascript:void(0)">
                                            <div class="account-logo">
                                                <a href="/"><img src="assets/img/logo-dark.png" alt="" /></a>
                                            </div>
                                            <div class="form-group"><span class="error">{errors["password"]}</span></div>
                                            <br></br>
                                            <div class="form-group">
                                                <label>Email</label>
                                                <input type="text" name="email" class="form-control" placeholder="Enter Email" onChange={this.changeHandler('email')} onKeyPress={this.onEnter} />
                                                <span className="error">{errors["email"]}</span>
                                            </div>
                                            <label>Password</label>
                                            <div class="form-group">
                                            <div class="input-group">
                                                <input type={type} class="form-control border-right-0" placeholder="password" onChange={this.changeHandler('password')} onKeyPress={this.onEnter} />
                                                <span class="input-group-prepend">
                                                <a href="javascript:void(0)" class="input-group-text border-left-0 bg-transparent material-icons" onClick={this.onEye}>{icon}</a>
                                                    {/* <span class="" id="basic-addon1">+62</span> */}
                                                </span>
                                            </div>
                                            <span class="error">{errors["passwordkos"]}</span>
                                            </div>
                                            <div class="mb-4 form-check">
                                                <input type="checkbox" class="form-check-input" id="active" checked={this.state.formdata.remember} onChange={this.checkedHandler('remember')} />
                                                <label class="form-check-label" for="active">remember me</label>
                                            </div>
                                            <div class="form-group text-right">
                                                <a href="javascript:void(0)" onClick={ModalLupassHandler}>Forgot your password?</a>
                                            </div>
                                            <div class="form-group text-center">
                                                <button type="button" class="btn btn-primary account-btn" onClick={this.onSignIn}>Login</button>
                                            </div>
                                            <div class="text-center register-link">
                                                Don’t have an account? <a href="javascript:void(0)" onClick={ModalRegHandler}>Register Now</a>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </Modal.Body>
                </Modal>
            </div>
        )
    }
}